export interface ESProperty {
	propertyName: string
	displayName: string
	weight: number
	searchEnabled: boolean
	returnInResults: boolean
}

export interface NestedESProperty extends ESProperty {
	nestedFields: ESProperty[]
}

export interface ElasticsearchConfig {
	codeSystem: CodeSystem
	indexName: string
	minimumScore: number
	minimumNestedFieldScore: number
	maximumNestedFieldValues: number
	displayScore: boolean
	properties: ESProperty[]
	nestedProperties?: NestedESProperty[]
	facetFields?: string[]
	configVersion?: number
}

export type EsConfigMap = Partial<Record<CodeSystem, ElasticsearchConfig>>

export enum CodeSystem {
	Adm = 'adm',
	Icd10 = 'icd10',
	Icpc2 = 'icpc2',
	Icpc2b = 'icpc2b',
	Nkpk = 'nkpk',
	Phbu = 'phbu',
	Norpat = 'norpat',
	Apat = 'apat',
	Nlk = 'nlk',
	provemateriale = 'provemateriale',
	anatomisk = 'anatomisk',
	snomedct = 'snomedct',
	snomed = 'snomed',
	tekstligeresultatverdier = 'tekstligeresultatverdier',
	undersokelsesmetode = 'undersokelsesmetode',
}
